import { render } from "./dashboard_admin.vue?vue&type=template&id=342a1214"
import script from "./dashboard_admin.vue?vue&type=script&lang=js"
export * from "./dashboard_admin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__